import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative overflow-hidden bg-[#0a0a0a] pt-16 md:pt-24 pb-16 md:pb-32" data-id="element-71">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 -mr-32 -mt-32 opacity-5 pointer-events-none text-[#d4a437]" data-id="element-72">
        <svg width="600" height="600" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" data-id="element-73">
          <path fill="currentColor" d="M44.7,-76.4C58.8,-69.2,71.8,-59.1,81.3,-46.3C90.8,-33.5,96.8,-18,96.5,-2.8C96.2,12.4,89.6,27.3,80.1,40.1C70.6,52.9,58.2,63.6,44.1,71.4C30,79.2,15,84.1,0.3,83.6C-14.4,83.1,-28.8,77.2,-41.7,69.1C-54.6,61,-66,50.7,-74.6,38.2C-83.2,25.7,-89,11,-88.7,-3.6C-88.4,-18.2,-82,-32.7,-72.6,-44.6C-63.2,-56.5,-50.8,-65.8,-37.6,-73.4C-24.4,-81,-12.2,-86.9,1.4,-89.3C15,-91.7,30.6,-83.6,44.7,-76.4Z" transform="translate(100 100)" data-id="element-74" />
        </svg>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-75">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-76">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-start text-left" data-id="element-77">
            <div className="inline-flex items-center rounded-full border border-[#d4a437]/30 bg-[#d4a437]/10 px-3 py-1 text-xs font-medium text-[#d4a437] mb-6" data-id="element-78">
              <span className="flex h-2 w-2 rounded-full bg-[#d4a437] mr-2" data-id="element-79"></span>
              OPERA DESDE CASA · 100% PRIVADO
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white mb-6 leading-tight" data-id="element-80">
              Affiliate Wave: Cómo Construir un Negocio en Dólares desde la
              Seguridad de tu Casa <br data-id="element-81" />
              <span className="font-serif text-[#d4a437] italic font-normal" data-id="element-82">
                (Sin Exponerte, Sin Riesgos)
              </span>
            </h1>

            <h2 className="text-xl md:text-2xl text-neutral-300 font-light mb-8 leading-relaxed" data-id="element-83">
              Protege tu futuro y el de tu familia con un sistema de afiliados
              "sin rostro" que puedes operar al 100% de forma privada, sin tener
              que salir a la calle ni mostrarte ante nadie.
            </h2>

            <div className="space-y-4 text-neutral-400 mb-10 text-base md:text-lg leading-relaxed" data-id="element-84">
              <p data-id="element-85">
                Sabemos que hoy, para ti, cruzar la puerta de tu casa no es solo
                ir a trabajar; es un acto de valentía que genera una ansiedad
                constante. El miedo a no regresar, a que una luz roja o un
                control inesperado te separe de lo que más amas, es una carga
                que nadie debería llevar mientras intenta sacar adelante a su
                familia en este país.
              </p>
              <p data-id="element-86">
                La incertidumbre de depender de un trabajo físico en el
                "exterior" es el riesgo más grande que estás corriendo. Pero, ¿y
                si tu mayor fuente de ingresos estuviera dentro de tus cuatro
                paredes, protegida por tu conexión a internet y operada bajo un
                anonimato total?
              </p>
            </div>

            <div className="w-full sm:w-auto flex flex-col items-center sm:items-start gap-3" data-id="element-87">
              <a href="https://d4chc.bemobtracks.com/click" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto inline-flex h-14 items-center justify-center rounded-md bg-[#d4a437] px-8 text-base font-bold text-[#0a0a0a] transition-all hover:bg-[#b88c2e] hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_20px_rgba(212,164,55,0.3)]" data-id="element-88">
                PROTEGE MI FUTURO — ÚNETE A AFFILIATE WAVE
              </a>
              <p className="text-xs text-neutral-500 flex items-center gap-2" data-id="element-89">
                <svg className="w-4 h-4 text-[#d4a437]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-90">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-91" />
                </svg>
                Acceso inmediato · Sin mostrar tu rostro · Comunidad oficial de
                Gus Sevilla
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative w-full max-w-lg mx-auto lg:max-w-none lg:ml-auto" data-id="element-92">
            <div className="absolute -inset-1 rounded-2xl bg-[#d4a437]/20 blur-xl" data-id="element-93"></div>
            <div className="relative rounded-2xl overflow-hidden border border-[#d4a437]/30 bg-[#111] shadow-2xl" data-id="element-94">
              <img src="https://cdn.magicpatterns.com/uploads/9GRuadjWfgeoR7Q2Cpowfk/Affiliate_wave_2.jpg" alt="Affiliate Wave Dashboard - Earn from home safely" className="w-full h-auto object-cover" data-id="element-95" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}